module.exports = __webpack_public_path__ + "static/media/fairtrade.f05edea8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cta/fairtrade.jpg
// module id = 376
// module chunks = 0